import 'bootstrap/dist/css/bootstrap.min.css'
import './css/animation.css';
import './css/socialicious-lite.css';
import './css/preload.css';
import 'sweetalert/dist/sweetalert.css'

import 'url-polyfill';
import 'mdn-polyfills/Element.closest'; 

import 'reflect-metadata';
import 'zone.js';

import { NgModule, ViewEncapsulation, ErrorHandler, enableProdMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

//TODO: move back to @ng-bootstrap once it supports modal animations
// https://github.com/ng-bootstrap/ng-bootstrap/issues/894
import { NgbModule } from '@mattlewis92/ng-bootstrap';

import { UIRouterModule } from '@uirouter/angular';
import { UrlService } from '@uirouter/core'

import { States, config } from './states';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';

import { Ng2ImgMaxModule } from 'ng2-img-max'; 
import { Location } from '@angular/common';

import { FullSearchComponent } from './components/full-search/full-search';
import { BookComponent } from './components/book/book';
import { HomeComponent } from './components/home/home';
import { AppComponent, UserReportModalComponent } from './components/app/app';
import { ShelvableBackend } from './services/ShelvableBackend/ShelvableBackend'
import { SearchConfigService } from './services/SearchConfigService'
import { GoogleData } from './services/GoogleData/GoogleData'
import { MapToIterable } from './services/MapToIterable'
import { ImageResizer } from './services/ImageResizer'
import { BookModalComponent, AffiliateInfoModalComponent } from './components/book-modal/book-modal'
import { GoogleViewerComponent } from './components/google-viewer/google-viewer'
import { BookPopoverComponent } from './components/book-popover/book-popover'
import { SearchComponent } from './components/search/search'
import { LoadingAnimationComponent } from './components/loading-animation/loading-animation'
import { GettingStartedPopover } from './components/getting-started-popover/getting-started-popover'
import { UserManagementComponent } from './components/user-management/user-management'
import { ConfigData } from './services/ConfigData'
import { ImporterComponent } from './components/importer/importer'
import { ImportFinderComponent } from './components/import-finder/import-finder'
import { PrivacyComponent } from './components/privacy/privacy'
import { ImageCropComponent } from './components/image-crop/image-crop' 
import { ErrorPageComponent } from './components/error-page/error-page' 
import { ExploreAuthorComponent } from './components/explore-author/explore-author'
import { UserLibraryComponent } from './components/user-library/user-library' 
import { ShelfSettingsComponent } from './components/shelf-settings/shelf-settings' 
import { UserShelfComponent } from './components/user-shelf/user-shelf' 
import { BarcodeScannerComponent } from './components/barcode-scanner/barcode-scanner' 

import { ScrollParentDirective } from './services/directives/ScrollParent'
import { CancelContextMenuDirective } from './services/directives/CancelContextMenu'
import { PopoverNudgerDirective } from './services/directives/PopoverNudger'
import { PopoverClassDirective } from './services/directives/PopoverClass';
import { FixPositionDirective } from './services/directives/FixPosition'
import { PopoverIsOpenDirective } from './services/directives/PopoverIsOpen'
import { BindToSubjectDirective } from './services/directives/BindToSubject'
import { BindCheckboxToSubjectDirective } from './services/directives/BindCheckboxToSubject'

import { AllowDragDirective } from './components/book/directives/AllowDrag';
import { AllowDropDirective } from './components/book/directives/AllowDrop';
import { EndGhostBookDirective } from './components/book/directives/GhostBook';
import { StopEventDirective } from './services/directives/StopEvent';
import { OnEnterPressDirective } from './services/directives/OnEnterPress'
import { OnParentClickDirective } from './services/directives/OnParentClick'

import { NgbRadioGroupValueDirective } from './services/directives/NgbRadioGroupValue'

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ImageCropperModule } from 'ng2-img-cropper';

import { Analytics } from './services/Analytics'

import { RavenStatic } from 'raven-js'
var Raven:RavenStatic = require('raven-js');

export class RavenErrorHandler implements ErrorHandler {
    handleError(err:any) : void {
        console.error(err);
        Raven.captureException(err);
    }
}

@NgModule({
    imports: [
        BrowserModule,
        UIRouterModule.forRoot({
            states: States,
            useHash: false,
            otherwise: { state: 'error' },
            config: config,
        }),
        NgbModule.forRoot(),

        // Use null here because we've already initialised above.
        // We're intialising above so that it happens at runtime.
        AngularFireModule.initializeApp(null),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        HttpClientModule,
        Ng2ImgMaxModule,
        InfiniteScrollModule,
        BrowserAnimationsModule,
        ImageCropperModule,
    ],
    declarations: [
        FullSearchComponent,
        BookComponent,
        HomeComponent,
        AppComponent,
        MapToIterable,
        BookPopoverComponent,
        PopoverClassDirective,
        BookModalComponent,
        AffiliateInfoModalComponent,
        GoogleViewerComponent,
        SearchComponent,
        ScrollParentDirective,
        CancelContextMenuDirective,
        PopoverNudgerDirective,
        LoadingAnimationComponent,
        GettingStartedPopover,
        UserManagementComponent,
        ImporterComponent,
        ImportFinderComponent,
        PrivacyComponent,
        ImageCropComponent,
        ErrorPageComponent,
        ExploreAuthorComponent,
        UserLibraryComponent,
        ShelfSettingsComponent,
        UserShelfComponent,
        AllowDragDirective,
        AllowDropDirective,
        EndGhostBookDirective,
        FixPositionDirective,
        PopoverIsOpenDirective,
        UserReportModalComponent,
        StopEventDirective,
        BindToSubjectDirective,
        BindCheckboxToSubjectDirective,
        OnEnterPressDirective,
        NgbRadioGroupValueDirective,
        OnParentClickDirective,
        BarcodeScannerComponent
    ],
    providers: [
        Location,
        ShelvableBackend,
        SearchConfigService,
        GoogleData,
        MapToIterable,
        ImageResizer,
        Analytics,
        // comment this if errors are being supressed
        { provide: ErrorHandler, useClass: RavenErrorHandler }
    ],
    bootstrap: [
        AppComponent
    ],
    entryComponents: [
        BookModalComponent,
        AffiliateInfoModalComponent,
        GoogleViewerComponent,
        UserManagementComponent,
        ImportFinderComponent,
        ImageCropComponent,
        ShelfSettingsComponent,
        UserReportModalComponent
    ]
})
export class ShelvableModule {
  constructor() { }
}

if (prodMode) {
    enableProdMode();
}

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initializeApp } from 'firebase'

window.configData.then((configData) => {
    ConfigData.data = configData;
    
    initializeApp({
        databaseURL: configData.firebaseUrl,
        apiKey: configData.firebaseApiKey,
        authDomain: configData.authDomain
    });

    platformBrowserDynamic().bootstrapModule(ShelvableModule);

    // this needs to be at the end - some errors weren't being logged when it was above @NgModule
    Raven.config(configData.sentryDSN, { environment: configData.ravenEnvironment }).install();
})





// WEBPACK FOOTER //
// ./web/static/entry.ts